import qs from 'qs'

type UsePrintRender = {
  isPrinting: boolean
  isEmbedding?: boolean
  isThumbnail: boolean
  isNotes: boolean
  isSimple?: boolean
  isLegend: boolean
  isTitle: boolean
  isPdf: boolean
}

type QueryParams = {
  print?: string
  embed?: string
  printable?: string
  notes?: string
  legend?: string
  header?: string
  simple?: string
  format?: string
  pdf?: string
}

const usePrintRender = (): UsePrintRender => {
  const params: QueryParams = qs.parse(window.location.search.replace('?', ''))

  return {
    isPrinting: params.print === 'true',
    isEmbedding: params.embed === 'true',
    isThumbnail: params.print === 'true' && params.format === 'thumbnail',
    isSimple: params.simple === 'true',
    isNotes:
      params.notes === 'true' ||
      (params.printable === 'true' && params.format === 'png'),
    isLegend: params.simple !== 'true' && params.legend === 'true',
    isTitle: params.header === 'true',
    isPdf: params.pdf === 'true',
  }
}

export default usePrintRender
